module.exports = __webpack_public_path__ + "img/icon_1.a1107cab.svg";